function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.771,45.164c0.595-6.734-5.683-8.699-8.174-8.699  c-9.656-0.002-19.315,0.001-28.972-0.008c1.39-3.025,3.085-11.046,0.95-22.097c-0.843-4.369-3.421-7.275-6.705-7.217  c-2.646,0.046-5.173,2.086-5.438,4.63c-0.29,2.797-0.977,6.78-1.627,9.504c-2.08,8.708-13.205,20.205-20.24,24.216v42.539  c4.772,2.697,9.947,3.641,15.474,3.536c8.732-0.167,33.675-0.021,38.195-0.051c3.199-0.021,6.389-1.547,7.923-5.409  c2.096-5.271-3.307-7.908-3.307-7.908s5.915,0.292,7.267-5.014c1.387-5.446-4.055-7.601-4.055-7.601  c3.68-0.402,6.036-1.36,6.927-4.677c1.047-3.907-1.466-6.841-5.444-8.539C91.148,52.31,97.225,51.328,97.771,45.164z M21.44,38.733  H5.19c-1.657,0-3,1.343-3,3v48.125c0,1.657,1.343,3,3,3h16.25c1.657,0,3-1.343,3-3V41.733C24.44,40.077,23.098,38.733,21.44,38.733z  "
});

var SvgThumbUp = function SvgThumbUp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgThumbUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumb-up.528a7f93.svg";
export { ForwardRef as ReactComponent };